import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

function NavItem({ label, path, icon }) {
  const [active, setActive] = useState(false)
  const { pathname } = useLocation()

  const sa_bg_color   = '#304861'
  const sa_text_color = 'white'
  const s_text_color  = '#304861'

  useEffect(() => {
    setActive(pathname === path.replace('.', ''))
  }, [path, pathname])

  return (
    <li>
      <Link
        to={path}
        onMouseEnter={(e) =>
          !active &&
          e.currentTarget.setAttribute(
            'style',
            `background-color: ${sa_bg_color}; color: ${sa_text_color}; fill: ${sa_text_color}`
          )
        }
        onMouseLeave={(e) =>
          !active &&
          e.currentTarget.setAttribute(
            'style',
            `background-color: transparent; color: ${s_text_color}; fill: ${s_text_color}`
          )
        }
        style={{
          backgroundColor: active ? sa_bg_color : '',
          color: active ? sa_text_color : s_text_color,
        }}
        className={`flex items-center p-2 rounded-lg ${
          sa_bg_color ? '' : 'hover:bg-gray-100'
        } group`}
      >
        {icon}
        <span className='ms-3'>{label}</span>
      </Link>
    </li>
  )
}

export default NavItem
